module.exports = __webpack_public_path__ + "img/telegram.d522a809.svg";